export function contentRevealScroll() {
    const prefersReducedMotion = window.matchMedia(
        '(prefers-reduced-motion: reduce)'
    ).matches;

    const context = gsap.context(() => {
        document.querySelectorAll('[data-reveal-group]').forEach((groupElement) => {
            const groupStagger =
                (parseFloat(groupElement.getAttribute('data-stagger')) || 100) / 1000;

            const groupDistance =
                groupElement.getAttribute('data-distance') || '2rem';

            const triggerStart =
                groupElement.getAttribute('data-start') || 'top 80%';

            const animationDuration = 0.8;
            const animationEase = 'power4.inOut';

            if (prefersReducedMotion) {
                gsap.set(groupElement, {
                    clearProps: 'all',
                    y: 0,
                    autoAlpha: 1
                });

                return;
            }

            const directChildren = Array.from(groupElement.children).filter(
                (element) => element.nodeType === Node.ELEMENT_NODE
            );

            if (!directChildren.length) {
                gsap.set(groupElement, {
                    y: groupDistance,
                    autoAlpha: 0
                });

                ScrollTrigger.create({
                    trigger: groupElement,
                    start: triggerStart,
                    once: true,
                    onEnter: () => {
                        gsap.to(groupElement, {
                            y: 0,
                            autoAlpha: 1,
                            duration: animationDuration,
                            ease: animationEase,
                            onComplete: () => {
                                gsap.set(groupElement, {
                                    clearProps: 'all'
                                });
                            }
                        });
                    }
                });

                return;
            }

            const slots = [];

            directChildren.forEach((child) => {
                const nestedGroup = child.matches('[data-reveal-group-nested]')
                    ? child
                    : child.querySelector(':scope [data-reveal-group-nested]');

                if (nestedGroup) {
                    const includeParent =
                        child.getAttribute('data-ignore') !== 'true' &&
                        (
                            child.getAttribute('data-ignore') === 'false' ||
                            nestedGroup.getAttribute('data-ignore') === 'false'
                        );

                    const nestedChildren = Array.from(nestedGroup.children).filter(
                        (element) =>
                            element.nodeType === Node.ELEMENT_NODE &&
                            element.getAttribute('data-ignore') !== 'true'
                    );

                    slots.push({
                        type: 'nested',
                        parentElement: child,
                        nestedElement: nestedGroup,
                        includeParent,
                        nestedChildren
                    });

                    return;
                }

                if (child.getAttribute('data-ignore') === 'true') {
                    return;
                }

                slots.push({
                    type: 'item',
                    element: child
                });
            });

            slots.forEach((slot) => {
                if (slot.type === 'item') {
                    const isNestedGroup = slot.element.matches(
                        '[data-reveal-group-nested]'
                    );

                    const distance = isNestedGroup
                        ? groupDistance
                        : slot.element.getAttribute('data-distance') || groupDistance;

                    gsap.set(slot.element, {
                        y: distance,
                        autoAlpha: 0
                    });

                    return;
                }

                if (slot.includeParent) {
                    gsap.set(slot.parentElement, {
                        y: groupDistance,
                        autoAlpha: 0
                    });
                }

                const nestedDistance =
                    slot.nestedElement.getAttribute('data-distance') ||
                    groupDistance;

                slot.nestedChildren.forEach((target) => {
                    gsap.set(target, {
                        y: nestedDistance,
                        autoAlpha: 0
                    });
                });
            });

            ScrollTrigger.create({
                trigger: groupElement,
                start: triggerStart,
                once: true,
                onEnter: () => {
                    const timeline = gsap.timeline();

                    slots.forEach((slot, slotIndex) => {
                        const slotTime = slotIndex * groupStagger;

                        if (slot.type === 'item') {
                            timeline.to(
                                slot.element,
                                {
                                    y: 0,
                                    autoAlpha: 1,
                                    duration: animationDuration,
                                    ease: animationEase,
                                    onComplete: () => {
                                        gsap.set(slot.element, {
                                            clearProps: 'all'
                                        });
                                    }
                                },
                                slotTime
                            );

                            return;
                        }

                        if (slot.includeParent) {
                            timeline.to(
                                slot.parentElement,
                                {
                                    y: 0,
                                    autoAlpha: 1,
                                    duration: animationDuration,
                                    ease: animationEase,
                                    onComplete: () => {
                                        gsap.set(slot.parentElement, {
                                            clearProps: 'all'
                                        });
                                    }
                                },
                                slotTime
                            );
                        }

                        const nestedStaggerAttribute = parseFloat(
                            slot.nestedElement.getAttribute('data-stagger')
                        );

                        const nestedStagger = Number.isNaN(
                            nestedStaggerAttribute
                        )
                            ? groupStagger
                            : nestedStaggerAttribute / 1000;

                        slot.nestedChildren.forEach(
                            (nestedChild, nestedIndex) => {
                                timeline.to(
                                    nestedChild,
                                    {
                                        y: 0,
                                        autoAlpha: 1,
                                        duration: animationDuration,
                                        ease: animationEase,
                                        onComplete: () => {
                                            gsap.set(nestedChild, {
                                                clearProps: 'all'
                                            });
                                        }
                                    },
                                    slotTime + nestedIndex * nestedStagger
                                );
                            }
                        );
                    });
                }
            });
        });
    });

    return () => context.revert();
}